import SafeHorizontal from "@components/safe-horizontal";
import ScreenScrollView from "@features/scroll-view/screen-scroll-view";
import { Container } from "dripsy";
import * as React from "react";

export default function TabScreenContainer({ children }: { children: any }) {
  return (
    <ScreenScrollView>
      <SafeHorizontal>
        <Container sx={{ mt: "$2", mb: "$8" }}>{children}</Container>
      </SafeHorizontal>
    </ScreenScrollView>
  );
}
